import React from 'react';
import { motion } from 'framer-motion';
import { XCircle, CheckCircle2 } from 'lucide-react';
export function SalesLetter() {
  const painPoints = [<>
      Quieres preparar café <strong data-id="element-137">como un barista profesional</strong>, pero
      desde tu propia cocina.
    </>, <>
      Sueñas con disfrutar <em data-id="element-138">bebidas de cafetería</em> sin tener que{' '}
      <u className="decoration-danger/50 decoration-2 underline-offset-2" data-id="element-139">
        salir de casa todos los días.
      </u>
    </>, <>
      Eres de los que entienden que el café{' '}
      <strong data-id="element-140">no es solo una bebida</strong>, es un{' '}
      <em data-id="element-141">ritual que define tu día.</em>
    </>, <>
      Amas el café y quieres entenderlo a fondo: sus{' '}
      <strong data-id="element-142">orígenes, aromas y secretos.</strong>
    </>, <>
      Tu café de todos los días{' '}
      <u className="decoration-danger/50 decoration-2 underline-offset-2" data-id="element-143">
        ya no te emociona
      </u>{' '}
      y sabes que podría ser <strong data-id="element-144">mucho mejor.</strong>
    </>];
  const solutions = [<>
      Aprenderás a preparar café como un barista, logrando{' '}
      <strong data-id="element-145">textura, aroma y sabor profesional.</strong>
    </>, <>
      <strong data-id="element-146">Dominarás técnicas</strong> para preparar bebidas de cafetería
      desde casa, con <em data-id="element-147">resultados increíbles.</em>
    </>, <>
      Entenderás el café de verdad: sus <strong data-id="element-148">orígenes, aromas</strong> y{' '}
      <strong data-id="element-149">métodos de preparación.</strong>
    </>, <>
      Aprenderás a crear <em data-id="element-150">recetas únicas</em>:{' '}
      <strong data-id="element-151">bebidas frías, calientes, con leche</strong> y{' '}
      <strong data-id="element-152">postres con café.</strong>
    </>, <>
      Dominarás el equilibrio entre{' '}
      <strong data-id="element-153">técnica, sabor y presentación</strong>, como en una cafetería
      profesional.
    </>];
  return <section className="py-10 md:py-14 px-4 bg-cream-200/50" data-id="element-154">
      <div className="max-w-3xl mx-auto" data-id="element-155">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-156">
          <p className="text-xl md:text-2xl text-espresso-800 leading-relaxed font-medium" data-id="element-157">
            Si estás aquí, es porque quieres disfrutar el café{' '}
            <strong data-id="element-158">de verdad</strong>: con sabor, técnica y estilo…{' '}
            <span className="italic text-gold-700" data-id="element-159">
              como si estuvieras en una cafetería.
            </span>
          </p>
          <p className="mt-4 text-lg text-espresso-700" data-id="element-160">
            <u className="decoration-gold-500 decoration-2 underline-offset-4" data-id="element-161">
              Despídete del café mediocre
            </u>{' '}
            y dale la bienvenida al arte de preparar café estilo cafetería{' '}
            <strong data-id="element-162">en casa.</strong>
          </p>
        </motion.div>

        {/* Pain Points */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white rounded-2xl p-6 md:p-8 shadow-sm border border-espresso-900/5 mb-8" data-id="element-163">
          <h2 className="text-2xl md:text-3xl font-bold text-espresso-900 mb-6 text-center" data-id="element-164">
            ESTE LIBRO DIGITAL ES PARA TI SI…
          </h2>
          <ul className="space-y-4" data-id="element-165">
            {painPoints.map((point, index) => <motion.li key={index} initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.08
          }} className="flex items-start gap-3" data-id="element-166">
                <XCircle className="w-6 h-6 text-danger flex-shrink-0 mt-0.5" data-id="element-167" />
                <span className="text-lg text-espresso-800" data-id="element-168">{point}</span>
              </motion.li>)}
          </ul>
        </motion.div>

        {/* Solutions */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-espresso-900 text-cream-100 rounded-2xl p-6 md:p-8 shadow-xl" data-id="element-169">
          <h2 className="text-2xl md:text-3xl font-bold text-gold-500 mb-6 text-center" data-id="element-170">
            ¿QUÉ APRENDERÁS CON EL ARTE DEL CAFÉ?
          </h2>
          <ul className="space-y-4" data-id="element-171">
            {solutions.map((point, index) => <motion.li key={index} initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.08
          }} className="flex items-start gap-3" data-id="element-172">
                <CheckCircle2 className="w-6 h-6 text-cta-600 flex-shrink-0 mt-0.5 bg-cream-100 rounded-full" data-id="element-173" />
                <span className="text-lg text-cream-200" data-id="element-174">{point}</span>
              </motion.li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}